import './Checkbox.css';
import React, { useId, useRef } from 'react';

export const Checkbox = ({
  label,
  checked,
  onChange,
}: {
  label?: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
  const fallbackId = useId();
  const id = label ? label.replace(/\s+/g, '-').toLowerCase() : fallbackId;
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className="checkbox-container">
      <input
        ref={inputRef}
        // Visually hidden but focusable, so the native checkbox handles keyboard and screen readers.
        className={'checkbox-input sr-only'}
        type="checkbox"
        id={`${id}-checkbox`}
        checked={checked}
        onChange={onChange}
      />
      {/* The drawn box; the hidden input above is the accessible control. */}
      <span aria-hidden="true" onClick={() => inputRef.current.click()}></span>
      <label htmlFor={`${id}-checkbox`}>{label}</label>
    </div>
  );
};
